export default {
  ECOMMERCE_INFO_LIST_REQUEST: 'APP/ECOMMERCE_INFO/ECOMMERCE_INFO_LIST_REQUEST',
  ECOMMERCE_INFO_LIST_SUCCESS: 'APP/ECOMMERCE_INFO/ECOMMERCE_INFO_LIST_SUCCESS',
  ECOMMERCE_INFO_LIST_ERROR: 'APP/ECOMMERCE_INFO/ECOMMERCE_INFO_LIST_ERROR',
};
